import {computed, reactive, ref, watch} from "vue";

export default function useEditarContatoDialog(props, emit) {
  const dialogVisible = ref(false);
  const formRef = ref(null);
  const duplicateInfo = ref(null);
  const emailDuplicado = ref("");
  const telefoneDuplicado = ref("");

  const form = reactive({
    nome_representante: "",
    cargo_representante: "",
    telefone: "",
    email: "",
  });

  const sanitizeTelefone = (value) => {
    return (value || "").replace(/\D/g, "").slice(0, 11);
  };

  const formatTelefoneDisplay = (digits) => {
    if (!digits) return "";
    if (digits.length <= 2) return `(${digits}`;
    if (digits.length <= 6) return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    if (digits.length <= 10) return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
  };

  const telefoneMasked = computed({
    get: () => formatTelefoneDisplay(form.telefone),
    set: (value) => {
      form.telefone = sanitizeTelefone(value);
    }
  });

  const preencherForm = (contato) => {
    const contatoSeguro = contato || {};
    form.nome_representante = contatoSeguro.nome_representante || "";
    form.cargo_representante = contatoSeguro.cargo_representante || "";
    const telefoneOriginal = contatoSeguro.telefone || contatoSeguro.whatsapp || "";
    form.telefone = sanitizeTelefone(telefoneOriginal);
    form.email = contatoSeguro.email || "";
  };

  watch(
    () => props.visible,
    (newVal) => {
      dialogVisible.value = newVal;
      if (newVal) {
        preencherForm(props.contato);
        duplicateInfo.value = null;
        emailDuplicado.value = "";
        telefoneDuplicado.value = "";
        if (formRef.value) {
          formRef.value.resetValidation();
        }
      }
    },
    {immediate: true}
  );

  watch(
    () => props.contato,
    (contato) => {
      if (dialogVisible.value) {
        preencherForm(contato);
      }
    }
  );

  watch(dialogVisible, (newVal, oldVal) => {
    if (!newVal && oldVal && props.handleClose) {
      props.handleClose();
    }
  });

  watch(() => form.email, () => {
    if (emailDuplicado.value) {
      emailDuplicado.value = "";
      if (formRef.value) {
        formRef.value.validate();
      }
    }
  });

  watch(() => form.telefone, () => {
    if (telefoneDuplicado.value) {
      telefoneDuplicado.value = "";
      if (formRef.value) {
        formRef.value.validate();
      }
    }
  });

  const closeDialog = () => {
    duplicateInfo.value = null;
    emailDuplicado.value = "";
    telefoneDuplicado.value = "";
    dialogVisible.value = false;
    if (props.handleClose) {
      props.handleClose();
    }
  };

  const limparDuplicado = () => {
    duplicateInfo.value = null;
  };

  const handleSalvar = () => {
    emailDuplicado.value = "";
    telefoneDuplicado.value = "";

    if (formRef.value) {
      const valido = formRef.value.validate();
      if (!valido) {
        return;
      }
    }

    const contatoSeguro = props.contato || {};
    emit("salvar", {
      ...form,
      cotacao_representante_fornecedor_id: contatoSeguro.cotacao_representante_fornecedor_id,
    }, (resultado) => {
      if (resultado && resultado.duplicate) {
        duplicateInfo.value = {
          ...resultado,
          fornecedorNome: resultado.fornecedorNome || (props.fornecedor && (props.fornecedor.razao_social || props.fornecedor.nome_fantasia)) || "",
        };
        if (resultado.campoDuplicado === 'email') {
          emailDuplicado.value = resultado.message || "Já existe um representante de fornecedor com o email informado";
          if (formRef.value) {
            formRef.value.validate();
          }
        } else if (resultado.campoDuplicado === 'telefone') {
          telefoneDuplicado.value = resultado.message || "Já existe um representante de fornecedor com o WhatsApp informado";
          if (formRef.value) {
            formRef.value.validate();
          }
        }
      } else if (resultado && resultado.success) {
        duplicateInfo.value = null;
        closeDialog();
      }
    });
  };

  const requiredRule = (value) => {
    if (!value || value.toString().trim() === "") {
      return "Campo obrigatório";
    }
    return true;
  };

  const whatsappRule = () => {
    return form.telefone.length >= 10 || "Formato inválido";
  };

  const emailRule = (value) => {
    if (!value || value.toString().trim() === "") {
      return "Campo obrigatório";
    }
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(value.trim()) || "Formato inválido";
  };

  const emailDuplicadoRule = () => {
    return emailDuplicado.value || true;
  };

  const telefoneDuplicadoRule = () => {
    return telefoneDuplicado.value || true;
  };

  const formatCNPJ = (cnpj) => {
    if (!cnpj) return "—";
    const numbers = cnpj.toString().replace(/\D/g, "");
    if (numbers.length === 14) {
      return numbers.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, "$1.$2.$3/$4-$5");
    }
    return cnpj;
  };

  return {
    dialogVisible,
    formRef,
    duplicateInfo,
    form,
    telefoneMasked,
    closeDialog,
    handleSalvar,
    limparDuplicado,
    requiredRule,
    whatsappRule,
    emailRule,
    emailDuplicadoRule,
    telefoneDuplicadoRule,
    formatCNPJ,
  };
}
